import config from "@/config/env";

export const anomalySummaryApi = {
  getSummary: async (startDateTime?: string | null, endDateTime?: string | null): Promise<any> => {
    const params = new URLSearchParams();
    if (startDateTime) params.append("start_time", startDateTime);
    if (endDateTime) params.append("end_time", endDateTime);

    const query = params.toString();
    const url = query
      ? `${config.api.anomalyUrl}/summary?${query}`
      : `${config.api.anomalyUrl}/summary`;

    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    return res.json();
  },
};
